import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Input } from "./ui/input";
import { ChevronDown } from "lucide-react";

export default function EventPicker({ events, value, onChange, testid, placeholder = "Search events…", allowNone = false }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const list = events.filter(e =>
    `${e.title} ${e.date} ${e.event_type}`.toLowerCase().includes(q.toLowerCase())
  );
  const current = events.find(e => e.id === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className="w-full flex items-center justify-between gap-2 rounded-md border border-white/10 bg-neutral-900 px-3 py-2 text-sm text-left text-neutral-200 hover:border-[var(--sn-gold)]/50 transition">
          <span className="truncate">{current ? `${current.title} · ${current.date}` : placeholder}</span>
          <ChevronDown className="w-4 h-4 text-neutral-500 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-2 bg-neutral-900 border-neutral-700 w-[var(--radix-popover-trigger-width)]" align="start">
        <Input autoFocus placeholder="Type to search…" value={q} onChange={(e) => setQ(e.target.value)}
          data-testid={`${testid}-search`}
          className="mb-2 h-8 text-sm bg-black/40 border-white/10" />
        <div className="max-h-56 overflow-y-auto space-y-0.5">
          {allowNone && (
            <button type="button" data-testid={`${testid}-option-none`}
              onClick={() => { onChange(""); setOpen(false); setQ(""); }}
              className="w-full text-left px-2 py-1.5 rounded text-sm text-neutral-400 hover:bg-white/5">
              — None —
            </button>
          )}
          {list.map(e => (
            <button key={e.id} type="button" data-testid={`${testid}-option-${e.id}`}
              onClick={() => { onChange(e.id); setOpen(false); setQ(""); }}
              className={`w-full text-left px-2 py-1.5 rounded text-sm hover:bg-white/5 ${e.id === value ? "text-[var(--sn-gold)]" : "text-neutral-300"}`}>
              {e.title} <span className="text-xs text-neutral-500">· {e.date} · {e.event_type}</span>
            </button>
          ))}
          {!list.length && <div className="text-xs text-neutral-500 px-2 py-2">No matching events</div>}
        </div>
      </PopoverContent>
    </Popover>
  );
}
